
// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import BaoDialogViewModel from "../../factories/bao-dialog";
import Bao from "./../../services/bao-service";

class UserQuickStartModuleDialog {
    UserQuickStartModuleCollection: KnockoutObservableArray<any> = ko.observableArray([]);
    IdsToRemove: Array<string> = [];
    constructor(dialog: BaoDialogViewModel) {
        this.GetCustomQuickStartModules();
    }
    GetCustomQuickStartModules = () => {
        Bao.post("StartModule/GetCustomQuickStartModules").done(result => {
            this.UserQuickStartModuleCollection(result);
        });
    };
    RemoveRow(entry) {
        this.IdsToRemove.push(entry.Id);
        this.UserQuickStartModuleCollection.remove(entry);
    }
}
export default UserQuickStartModuleDialog;